module.exports = __webpack_public_path__ + "img/mobile-catch.9725ea67.png";